import { PaymentMethodTypes } from '../../components/PaymentCaptureMethod/constants.ts';

/**
 * Returns formatted payment method display information
 * @param {string} paymentType - The payment method type
 * @param {Object} paymentDetails - Payment details object
 * @param {string} paymentDetails.cardNumber - Card number for card payments
 * @param {string} paymentDetails.creditCardType - Card type (visa, mastercard, etc.)
 * @returns {string} The formatted display text
 */
export const getPaymentMethodDisplayText = (paymentType, cardNumber) => {
  switch (paymentType) {
    case PaymentMethodTypes.Card: {
      if (cardNumber) return `Card ending **** ${cardNumber}`;
      return 'Card ending ****';
    }
    case PaymentMethodTypes.ApplePay:
      return 'Apple Pay';
    case PaymentMethodTypes.GooglePay:
      return 'Google Pay';
    default:
      return 'Payment method';
  }
};
